import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { ROUTES } from './constants';

type AuthorizedAdminRouterProps = {
    isAdmin: boolean;
    children: React.ReactNode;
};

const AuthorizedAdminRouter = ({ isAdmin, children }: AuthorizedAdminRouterProps) => {
    const jwt = localStorage.getItem('jwt');
    const userType = localStorage.getItem('user_type');
    const userId = localStorage.getItem('user_id');

    if (jwt && userType && userId && isAdmin) {
        return <Outlet />;
    } else if (!jwt || !userType || !userId) {
        return <Navigate to={ROUTES.LOGIN} replace />;
    } else if (jwt && userType && userId && !isAdmin) {
        return <Navigate to={ROUTES.ERROR} replace />;
    } else {
        return <Navigate to={ROUTES.LOGIN} replace />;
    }
};

export default AuthorizedAdminRouter;